module.exports = __webpack_public_path__ + "static/Corona-Modelo-Lunch-Truck-Action-SoCa-9-2-19-20-1344b5fde7a3cc8a381f8070bdc4771a.jpg";